<template>
  <div>
    <!-- Contact Us Intro Section -->
    <div class="contactIntro d-flex justify-content-center align-items-center text-center py-5">
      <div class="contactIntroContent">
        <h1 class="display-4">Get in Touch</h1>
        <p class="lead">We're here to help you with any questions or concerns you may have.</p>
        <p>Our team at My Soft Code is dedicated to providing top-notch support and solutions tailored to your needs. Reach out to us, and we'll be happy to assist you.</p>
      </div>
    </div>

    <!-- Contact Form Section -->
    <div class="contactFormSection d-flex flex-column align-items-center py-5">
      <div class="contactForm w-100 w-md-75 w-lg-50">
        <form @submit.prevent="handleSubmit">
          <div class="row mb-4">
            <div class="col-md-6">
              <div class="form-group">
                <label for="name" class="form-label">Name</label>
                <input type="text" id="name" class="form-control" v-model="form.name" required />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="email" class="form-label">Email</label>
                <input type="email" id="email" class="form-control" v-model="form.email" required />
              </div>
            </div>
          </div>

          <!-- ✅ New Phone Number Field -->
          <div class="form-group mb-4">
            <label for="phone" class="form-label">Phone Number</label>
            <input
              type="tel"
              id="phone"
              class="form-control"
              v-model="form.phone"
              placeholder="+94 71 234 5678"
              required
            />
          </div>

          <div class="form-group mb-4">
            <label for="message" class="form-label">Message</label>
            <textarea id="message" class="form-control" rows="5" v-model="form.message" required></textarea>
          </div>

          <!-- ✅ Loading Button -->
          <button type="submit" class="btn btn-primary d-flex align-items-center justify-content-center" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
            {{ loading ? 'Sending...' : 'Send Message' }}
          </button>
        </form>
      </div>
    </div>

    <!-- Contact Info Section -->
    <div class="contactInfoSection d-flex flex-column align-items-center py-5">
      <h2 class="display-5 mb-3">Our Contact Information</h2>

      <div class="info-item d-flex align-items-center mb-3">
        <i class="bi bi-whatsapp fa-2x me-3" style="color: #25D366;"></i>
        <a :href="'https://wa.me/94713246947'" target="_blank" class="text-decoration-none text-dark">
          +94 71 324 6947 (WhatsApp)
        </a>
      </div>

      <div class="info-item d-flex align-items-center mb-3">
        <i class="bi bi-envelope fa-2x me-3"></i>
        <span>info@mysoftcode.com</span>
      </div>
      <div class="info-item d-flex align-items-center mb-3">
        <i class="bi bi-geo-alt fa-2x me-3"></i>
        <span>Dambulla, Sri Lanka</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '', // ✅ new field
        message: ''
      },
      loading: false
    };
  },
  methods: {
    async handleSubmit() {
      this.loading = true;
      try {
        await axios.post('/send-contact-email', this.form, {
          headers: { 'Content-Type': 'application/json' }
        });

        alert('✅ Message sent successfully!');
        this.form = { name: '', email: '', phone: '', message: '' };
      } catch (error) {
        console.error(error);
        alert('❌ Failed to send message. Please try again later.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contactIntro {
  width: 100%;
  height: 80vh;
  background-color: #6c757d;
  color: #fff;
  padding: 2rem;
  background-image: url('@/assets/Contact/ContactImg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

.contactIntroContent {
  max-width: 800px;
}

.contactIntro h1 {
  color: #ffd900;
}

.contactIntro p {
  font-size: 1.125rem;
}

.contactFormSection {
  background-color: #a8a8a8;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.contactForm .form-control {
  border-radius: 5px;
}

.contactForm .btn-primary {
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  padding: 0.75rem 1.5rem;
}

.contactForm .btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.contactInfoSection {
  text-align: center;
}

.info-item {
  color: #343a40;
}

.info-item i {
  color: #007bff;
}

.info-item span {
  font-size: 1.125rem;
}

a.text-dark:hover {
  color: #25D366;
}

@media (max-width: 767px) {
  .contactFormSection {
    padding: 1.5rem;
  }
}
</style>
